import { render, staticRenderFns } from "./LoaddingPage.vue?vue&type=template&id=1a50baac&"
import script from "./LoaddingPage.vue?vue&type=script&lang=js&"
export * from "./LoaddingPage.vue?vue&type=script&lang=js&"
import style0 from "./LoaddingPage.vue?vue&type=style&index=0&id=1a50baac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports